/*
 * Created on Mon Nov 13 2023
 *
 * Copyright (c) 2023 Your Company
 */

import { AllHTMLAttributes } from "react";

const HTMLAttrs: { [key: string]: string } = {
  accept: "accept",
  acceptCharset: "acceptCharset",
  action: "action",
  allowFullScreen: "allowFullScreen",
  allowTransparency: "allowTransparency",
  alt: "alt",
  as: "as",
  async: "async",
  autoComplete: "autoComplete",
  autoPlay: "autoPlay",
  capture: "capture",
  cellPadding: "cellPadding",
  cellSpacing: "cellSpacing",
  charSet: "charSet",
  challenge: "challenge",
  checked: "checked",
  cite: "cite",
  classID: "classID",
  cols: "cols",
  colSpan: "colSpan",
  content: "content",
  controls: "controls",
  coords: "coords",
  crossOrigin: "crossOrigin",
  data: "data",
  dateTime: "dateTime",
  default: "default",
  defer: "defer",
  disabled: "disabled",
  download: "download",
  encType: "encType",
  form: "form",
  formAction: "formAction",
  formEncType: "formEncType",
  formMethod: "formMethod",
  formNoValidate: "formNoValidate",
  formTarget: "formTarget",
  frameBorder: "frameBorder",
  headers: "headers",
  height: "height",
  high: "high",
  href: "href",
  hrefLang: "hrefLang",
  htmlFor: "htmlFor",
  httpEquiv: "httpEquiv",
  integrity: "integrity",
  keyParams: "keyParams",
  keyType: "keyType",
  kind: "kind",
  label: "label",
  list: "list",
  loop: "loop",
  low: "low",
  manifest: "manifest",
  marginHeight: "marginHeight",
  marginWidth: "marginWidth",
  max: "max",
  maxLength: "maxLength",
  media: "media",
  mediaGroup: "mediaGroup",
  method: "method",
  min: "min",
  minLength: "minLength",
  multiple: "multiple",
  muted: "muted",
  name: "name",
  noValidate: "noValidate",
  open: "open",
  optimum: "optimum",
  pattern: "pattern",
  placeholder: "placeholder",
  playsInline: "playsInline",
  poster: "poster",
  preload: "preload",
  readOnly: "readOnly",
  rel: "rel",
  required: "required",
  reversed: "reversed",
  rows: "rows",
  rowSpan: "rowSpan",
  sandbox: "sandbox",
  scope: "scope",
  scoped: "scoped",
  scrolling: "scrolling",
  seamless: "seamless",
  selected: "selected",
  shape: "shape",
  size: "size",
  sizes: "sizes",
  span: "span",
  src: "src",
  srcDoc: "srcDoc",
  srcLang: "srcLang",
  srcSet: "srcSet",
  start: "start",
  step: "step",
  summary: "summary",
  target: "target",
  type: "type",
  useMap: "useMap",
  value: "value",
  width: "width",
  wmode: "wmode",
  wrap: "wrap",

  defaultChecked: "defaultChecked",
  defaultValue: "defaultValue",
  suppressContentEditableWarning: "suppressContentEditableWarning",
  suppressHydrationWarning: "suppressHydrationWarning",

  // Standard HTML Attributes
  accessKey: "accessKey",
  autoFocus: "autoFocus",
  className: "className",
  contentEditable: "contentEditable",
  contextMenu: "contextMenu",
  dir: "dir",
  draggable: "draggable",
  hidden: "hidden",
  id: "id",
  lang: "lang",
  nonce: "nonce",
  slot: "slot",
  spellCheck: "spellCheck",
  style: "style",
  tabIndex: "tabIndex",
  title: "title",
  translate: "translate",

  // Unknown
  radioGroup: "radioGroup",

  // WAI-ARIA
  role: "role",

  // RDFa Attributes
  about: "about",
  datatype: "datatype",
  inlist: "inlist",
  prefix: "prefix",
  property: "property",
  resource: "resource",
  typeof: "typeof",
  vocab: "vocab",

  // Non-standard Attributes
  autoCapitalize: "autoCapitalize",
  autoCorrect: "autoCorrect",
  autoSave: "autoSave",
  color: "color",
  itemProp: "itemProp",
  itemScope: "itemScope",
  itemType: "itemType",
  itemID: "itemID",
  itemRef: "itemRef",
  results: "results",
  security: "security",
  unselectable: "unselectable",
  inputMode: "inputMode",
  is: "is",

  "aria-activedescendant": "aria-activedescendant",
  "aria-atomic": "aria-atomic",
  "aria-autocomplete": "aria-autocomplete",
  "aria-busy": "aria-busy",
  "aria-checked": "aria-checked",
  "aria-colcount": "aria-colcount",
  "aria-colindex": "aria-colindex",
  "aria-colspan": "aria-colspan",
  "aria-controls": "aria-controls",
  "aria-current": "aria-current",
  "aria-describedby": "aria-describedby",
  "aria-details": "aria-details",
  "aria-disabled": "aria-disabled",
  "aria-dropeffect": "aria-dropeffect",
  "aria-errormessage": "aria-errormessage",
  "aria-expanded": "aria-expanded",
  "aria-flowto": "aria-flowto",
  "aria-grabbed": "aria-grabbed",
  "aria-haspopup": "aria-haspopup",
  "aria-hidden": "aria-hidden",
  "aria-invalid": "aria-invalid",
  "aria-keyshortcuts": "aria-keyshortcuts",
  "aria-label": "aria-label",
  "aria-labelledby": "aria-labelledby",
  "aria-level": "aria-level",
  "aria-live": "aria-live",
  "aria-modal": "aria-modal",
  "aria-multiline": "aria-multiline",
  "aria-multiselectable": "aria-multiselectable",
  "aria-orientation": "aria-orientation",
  "aria-owns": "aria-owns",
  "aria-placeholder": "aria-placeholder",
  "aria-posinset": "aria-posinset",
  "aria-pressed": "aria-pressed",
  "aria-readonly": "aria-readonly",
  "aria-relevant": "aria-relevant",
  "aria-required": "aria-required",
  "aria-roledescription": "aria-roledescription",
  "aria-rowcount": "aria-rowcount",
  "aria-rowindex": "aria-rowindex",
  "aria-rowspan": "aria-rowspan",
  "aria-selected": "aria-selected",
  "aria-setsize": "aria-setsize",
  "aria-sort": "aria-sort",
  "aria-valuemax": "aria-valuemax",
  "aria-valuemin": "aria-valuemin",
  "aria-valuenow": "aria-valuenow",
  "aria-valuetext": "aria-valuetext",

  children: "children",
  dangerouslySetInnerHTML: "dangerouslySetInnerHTML",
  onCopy: "onCopy",
  onCopyCapture: "onCopyCapture",
  onCut: "onCut",
  onCutCapture: "onCutCapture",
  onPaste: "onPaste",
  onPasteCapture: "onPasteCapture",
  onCompositionEnd: "onCompositionEnd",
  onCompositionEndCapture: "onCompositionEndCapture",
  onCompositionStart: "onCompositionStart",
  onCompositionStartCapture: "onCompositionStartCapture",
  onCompositionUpdate: "onCompositionUpdate",
  onCompositionUpdateCapture: "onCompositionUpdateCapture",
  onFocus: "onFocus",
  onFocusCapture: "onFocusCapture",
  onBlur: "onBlur",
  onBlurCapture: "onBlurCapture",
  onChange: "onChange",
  onChangeCapture: "onChangeCapture",
  onBeforeInput: "onBeforeInput",
  onBeforeInputCapture: "onBeforeInputCapture",
  onInput: "onInput",
  onInputCapture: "onInputCapture",
  onReset: "onReset",
  onResetCapture: "onResetCapture",
  onSubmit: "onSubmit",
  onSubmitCapture: "onSubmitCapture",
  onInvalid: "onInvalid",
  onInvalidCapture: "onInvalidCapture",
  onLoad: "onLoad",
  onLoadCapture: "onLoadCapture",
  onError: "onError",
  onErrorCapture: "onErrorCapture",
  onKeyDown: "onKeyDown",
  onKeyDownCapture: "onKeyDownCapture",
  onKeyPress: "onKeyPress",
  onKeyPressCapture: "onKeyPressCapture",
  onKeyUp: "onKeyUp",
  onKeyUpCapture: "onKeyUpCapture",
  onAbort: "onAbort",
  onAbortCapture: "onAbortCapture",
  onCanPlay: "onCanPlay",
  onCanPlayCapture: "onCanPlayCapture",
  onCanPlayThrough: "onCanPlayThrough",
  onCanPlayThroughCapture: "onCanPlayThroughCapture",
  onDurationChange: "onDurationChange",
  onDurationChangeCapture: "onDurationChangeCapture",
  onEmptied: "onEmptied",
  onEmptiedCapture: "onEmptiedCapture",
  onEncrypted: "onEncrypted",
  onEncryptedCapture: "onEncryptedCapture",
  onEnded: "onEnded",
  onEndedCapture: "onEndedCapture",
  onLoadedData: "onLoadedData",
  onLoadedDataCapture: "onLoadedDataCapture",
  onLoadedMetadata: "onLoadedMetadata",
  onLoadedMetadataCapture: "onLoadedMetadataCapture",
  onLoadStart: "onLoadStart",
  onLoadStartCapture: "onLoadStartCapture",
  onPause: "onPause",
  onPauseCapture: "onPauseCapture",
  onPlay: "onPlay",
  onPlayCapture: "onPlayCapture",
  onPlaying: "onPlaying",
  onPlayingCapture: "onPlayingCapture",
  onProgress: "onProgress",
  onProgressCapture: "onProgressCapture",
  onRateChange: "onRateChange",
  onRateChangeCapture: "onRateChangeCapture",
  onResize: "onResize",
  onResizeCapture: "onResizeCapture",
  onSeeked: "onSeeked",
  onSeekedCapture: "onSeekedCapture",
  onSeeking: "onSeeking",
  onSeekingCapture: "onSeekingCapture",
  onStalled: "onStalled",
  onStalledCapture: "onStalledCapture",
  onSuspend: "onSuspend",
  onSuspendCapture: "onSuspendCapture",
  onTimeUpdate: "onTimeUpdate",
  onTimeUpdateCapture: "onTimeUpdateCapture",
  onVolumeChange: "onVolumeChange",
  onVolumeChangeCapture: "onVolumeChangeCapture",
  onWaiting: "onWaiting",
  onWaitingCapture: "onWaitingCapture",

  // MouseEvents
  onAuxClick: "onAuxClick",
  onAuxClickCapture: "onAuxClickCapture",
  onClick: "onClick",
  onClickCapture: "onClickCapture",
  onContextMenu: "onContextMenu",
  onContextMenuCapture: "onContextMenuCapture",
  onDoubleClick: "onDoubleClick",
  onDoubleClickCapture: "onDoubleClickCapture",
  onDrag: "onDrag",
  onDragCapture: "onDragCapture",
  onDragEnd: "onDragEnd",
  onDragEndCapture: "onDragEndCapture",
  onDragEnter: "onDragEnter",
  onDragEnterCapture: "onDragEnterCapture",
  onDragExit: "onDragExit",
  onDragExitCapture: "onDragExitCapture",
  onDragLeave: "onDragLeave",
  onDragLeaveCapture: "onDragLeaveCapture",
  onDragOver: "onDragOver",
  onDragOverCapture: "onDragOverCapture",
  onDragStart: "onDragStart",
  onDragStartCapture: "onDragStartCapture",
  onDrop: "onDrop",
  onDropCapture: "onDropCapture",
  onMouseDown: "onMouseDown",
  onMouseDownCapture: "onMouseDownCapture",
  onMouseEnter: "onMouseEnter",
  onMouseLeave: "onMouseLeave",
  onMouseMove: "onMouseMove",
  onMouseMoveCapture: "onMouseMoveCapture",
  onMouseOut: "onMouseOut",
  onMouseOutCapture: "onMouseOutCapture",
  onMouseOver: "onMouseOver",
  onMouseOverCapture: "onMouseOverCapture",
  onMouseUp: "onMouseUp",
  onMouseUpCapture: "onMouseUpCapture",

  // Selection Events
  onSelect: "onSelect",
  onSelectCapture: "onSelectCapture",

  // Touch Events
  onTouchCancel: "onTouchCancel",
  onTouchCancelCapture: "onTouchCancelCapture",
  onTouchEnd: "onTouchEnd",
  onTouchEndCapture: "onTouchEndCapture",
  onTouchMove: "onTouchMove",
  onTouchMoveCapture: "onTouchMoveCapture",
  onTouchStart: "onTouchStart",
  onTouchStartCapture: "onTouchStartCapture",

  // Pointer Events
  onPointerDown: "onPointerDown",
  onPointerDownCapture: "onPointerDownCapture",
  onPointerMove: "onPointerMove",
  onPointerMoveCapture: "onPointerMoveCapture",
  onPointerUp: "onPointerUp",
  onPointerUpCapture: "onPointerUpCapture",
  onPointerCancel: "onPointerCancel",
  onPointerCancelCapture: "onPointerCancelCapture",
  onPointerEnter: "onPointerEnter",
  onPointerEnterCapture: "onPointerEnterCapture",
  onPointerLeave: "onPointerLeave",
  onPointerLeaveCapture: "onPointerLeaveCapture",
  onPointerOver: "onPointerOver",
  onPointerOverCapture: "onPointerOverCapture",
  onPointerOut: "onPointerOut",
  onPointerOutCapture: "onPointerOutCapture",
  onGotPointerCapture: "onGotPointerCapture",
  onGotPointerCaptureCapture: "onGotPointerCaptureCapture",
  onLostPointerCapture: "onLostPointerCapture",
  onLostPointerCaptureCapture: "onLostPointerCaptureCapture",

  // UI Events
  onScroll: "onScroll",
  onScrollCapture: "onScrollCapture",

  // Wheel Events
  onWheel: "onWheel",
  onWheelCapture: "onWheelCapture",

  // Animation Events
  onAnimationStart: "onAnimationStart",
  onAnimationStartCapture: "onAnimationStartCapture",
  onAnimationEnd: "onAnimationEnd",
  onAnimationEndCapture: "onAnimationEndCapture",
  onAnimationIteration: "onAnimationIteration",
  onAnimationIterationCapture: "onAnimationIterationCapture",

  // Transition Events
  onTransitionEnd: "onTransitionEnd",
  onTransitionEndCapture: "onTransitionEndCapture",
};

function checkDataSet(attrs: string) {
  const regex = /^data-/;
  return regex.test(attrs);
}

/**
 *  Row, Column, Grid를 사용하는 곳에서
 *  HTMLAttributes를 제외한 custom props가 boolean 혹은 camelCase일 경우 콘솔 에러가 발생하기 때문에,
 *  custom props를 필터링 처리하기 위한 임시 방편 코드입니다.
 * 	후에 이 에러를 해결하기 위한 다른 방법이 생기면 대체해야합니다.
 *
 * 	@param props 모든 props 객체
 * 	@return HTMLAttribute만 남고 나머지는 필터링된 객체
 */
export function filterHTMLAttribute(
  props: AllHTMLAttributes<HTMLElement> & Record<string, unknown>
) {
  const result = { ...props };

  Object.keys(result).forEach((attr) => {
    if (!HTMLAttrs[attr] && !checkDataSet(attr)) {
      delete result[attr];
    }
  });

  return result;
}

export function filterHTMLDataAttribute(
  props: AllHTMLAttributes<HTMLElement> & Record<string, unknown>
) {
  const result = { ...props };

  Object.keys(result).forEach((attr) => {
    if (!checkDataSet(attr)) {
      delete result[attr];
    }
  });

  return result;
}
